import { Component, inject, OnInit, TemplateRef, viewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { take } from 'rxjs/operators';

import { OcJsonSchemaValidatorAjv } from '../../../../core/oc-validator/oc-jsonSchemaValidatorAjv.service';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';
import { IError } from '@orgacard/login';
import { IAngularMyDpOptions, IMyDateModel } from 'gramli-angular-mydatepicker';
import moment from 'moment';

import { AppService } from '../../../../app.service';
import { CoreService } from '../../../../core/core.service';
import { EnvironmentService } from '../../../../core/environment.service';
import { ocValidator } from '../../../../core/oc-validator/oc.validator';
import { ModalService } from '../../../../core/services/modal.service';
import { UtilityHelperService } from '../../../../core/utility-helper.service';
import { LoadingOverlayService } from '../../../../loading-overlay/loading-overlay.service';
import { CostcentertreeService } from '../../../shared/costcentertree/costcentertree.service';
import { ICostcenter } from '../../../shared/models/basic.model';
import { ISupplierContract, ISupplierContractCostcenter, SupplierContractFilter } from '../../shared/models/supplier.model';
import { SupplierService } from '../../shared/services/supplier.service';

@UntilDestroy()
@Component({
    selector: 'app-contractdata',
    templateUrl: './contractdata.component.html',
    standalone: false,
})
export class ContractdataComponent implements OnInit {
    private readonly utilityHelperService = inject(UtilityHelperService);
    private modalService = inject(ModalService);
    private formBuilder = inject(FormBuilder);
    private appService = inject(AppService);
    coreService = inject(CoreService);
    environmentService = inject(EnvironmentService);
    private ocJsonSchemaValidatorAjv = inject(OcJsonSchemaValidatorAjv);
    supplierService = inject(SupplierService);
    private costcentertreeService = inject(CostcentertreeService);
    loadingOverlayService = inject(LoadingOverlayService);

    public readonly costcenterModalAssign = viewChild<TemplateRef<any>>('costcenterModalAssign');
    public readonly costcenterModalAssignAddMoreCostcenter = viewChild<TemplateRef<any>>('costcenterModalAssignAddMoreCostcenter');
    public readonly costcenterModalRoot = viewChild<TemplateRef<any>>('costcenterModalRoot');
    public readonly costcenterListModal = viewChild<TemplateRef<any>>('costcenterListModal');

    // disableUntil: this.coreService.convertToMyDate(moment(new Date()).subtract(1, "days").toDate())
    public validFromPickerOptions: IAngularMyDpOptions = {
        appendSelectorToBody: true,
        dateRange: false,
        dateFormat: 'dd.mm.yyyy',
        disableUntil: this.coreService.convertToMyDate(new Date()),
    };
    public validTillPickerOptions: IAngularMyDpOptions = {
        appendSelectorToBody: true,
        dateRange: false,
        dateFormat: 'dd.mm.yyyy',
        disableUntil: this.coreService.convertToMyDate(new Date()),
    };

    // datepickerHelper = new DatepickerHelper();
    // angular-mydatepicker NACHFOLGER VON mydatepicker !!!
    // https://github.com/kekeh/angular-mydatepicker/wiki
    // https://github.com/kekeh/angular-mydatepicker
    // https://github.com/kekeh/angular-mydatepicker/tree/master/example/app/date-picker-reactive-forms
    public contractDatepickerForm: FormGroup;

    public dateFrom: Date = new Date();

    // modelFrom: IMyDateModel = {isRange: false, singleDate: undefined, dateRange: null};
    // modelTill: IMyDateModel = {isRange: false, singleDate: undefined, dateRange: null};

    public supplierContractMainCostcenter: ISupplierContractCostcenter = undefined;

    public contractDataChanged: boolean = true;
    public costcenterTreeDisabled: boolean = false;
    public costcenterTreeExpandAll: boolean = false;
    public costcenterTreeTriState: boolean = true;

    public contractColumns: string[];
    public selectedRowIndex: number = -1;
    public showContractData: boolean = false;

    // reference to the enum
    // supplierContractFilter: SupplierContractFilter;
    public supplierContractFilter = SupplierContractFilter;
    public contractfiltervalue: SupplierContractFilter = this.supplierContractFilter.VALID;

    // costcenters: ICostcenter[] = this.costcentertreeService.costcenterTree.children;

    public costcenterModalHeadline: string = this.coreService.getMsgkey('mws.costcenters', undefined);
    public costcenterList: ICostcenter[] = [];
    public showCostcenterListCheckBox: boolean = false;
    public displayedCostcenterListColumns = [];

    public vereinbarungsrelevante: ICostcenter[] = [];
    public abweichendeBedingungenMoeglich: ICostcenter[] = [];
    public abweichendeBedingungenBereitsKundenExistent: ICostcenter[] = [];

    public noContractCostecenters: ICostcenter[];
    public possibleCostcenter: ICostcenter[];
    public assignCostcenter: ICostcenter[];

    public nodes = [];

    public get validFromControl(): FormControl {
        return this.contractDatepickerForm.get('validFrom') as FormControl;
    }

    public get validTillControl(): FormControl {
        return this.contractDatepickerForm.get('validTill') as FormControl;
    }

    public ngOnInit() {
        this.initTableColumns();
        this.initDatepicker();
        if (this.supplierService.method === 'EDIT' && this.supplierService.supplierId) {
            this.loadContracts();
        }
    }

    public cancelCostcenter() {
        this.modalService.closeAllModals();
    }

    /*
     VERTRAGSANLAGE - Schritt 1: ROOT Kostenstellen Auswahl
     */
    public checkRootCostcenterForContract(costcenter: ICostcenter) {
        // console.log('checkRootCostcenterForContract');
        if (costcenter) {
            console.log('checkRootCostcenterForContract - ausgewählte ROOT-Kostenstelle ID: ' + costcenter.id + ' NAME: ' + costcenter.name);

            this.supplierService.supplierContract = {} as ISupplierContract;

            this.supplierService.supplierContract.costcenterId = costcenter.id;

            // - hole relevante Kostenstellen ausgehend von: supplierContract.costcenterId --- ROOT-Kostenstelle
            // - öffne modales Fenster: ASSIGN-COSTCENTER
            // this.costcentertreeService.getCostcenterTreeWithoutValidContract(this.supplierService.supplierContract.costcenterId).subscribe(costcenters => {
            this.costcentertreeService
                .getCostcenterTreeByTreeNode(this.supplierService.supplierContract.costcenterId)
                .pipe(take(1))
                .subscribe(
                    (costcenters) => {
                        this.costcenterTreeDisabled = false;
                        this.costcenterTreeExpandAll = true;
                        this.costcenterTreeTriState = false;
                        // this.nodes = costcenters;
                        this.nodes = [];
                        this.nodes.push(costcenters);
                        const options: NgbModalOptions = { centered: false, backdrop: 'static', windowClass: 'modal-lg animate' };
                        this.modalService.openModal(this.costcenterModalAssign(), options);
                    },
                    (err: IError) => {
                        this.utilityHelperService.handleComponentError(err);
                    },
                );
        }
    }

    /*
     ASSIGNED Kostenstellen Auswahl

     VERTRAGSANLAGE - Schritt 2: Zugeordnete Kostenstellenauswahl
     --> MODAL: costcenterModalAssign

     */
    public checkAssignedCostcenterForContract(costcenterNodes: ICostcenter[]) {
        // console.log('checkAssignedCostcenterForContract');

        const costcenterAssigned = [];
        if (costcenterNodes.length > 0) {
            costcenterNodes.forEach((cn) => {
                console.log('checkAssignedCostcenterForContract - ausgewählte ASSIGNED- Kostenstellen ID: ' + cn.id + ' NAME: ' + cn.name);
                costcenterAssigned.push(cn.id);
            });
        }

        // 1) Vertragsanlage
        this.supplierService.supplierContract.id = undefined;
        // this.supplierService.supplierContract.supplierContractCostcenterCustomers = [];
        this.supplierService.supplierContract.validFrom = undefined; // moment().format(),
        this.supplierService.supplierContract.validTill = undefined;
        this.supplierService.supplierContract.supplierId = this.supplierService.supplierId;
        this.supplierService.supplierContract.costcentersAssigned = costcenterAssigned; // choosenCostcenterLeafs
        this.supplierService.supplierContract._costcenterDescription = undefined;
        this.supplierService.supplierContract._costcenterNumber = undefined;
        if (
            this.supplierService.supplierBasedata.supplierStatus.length === 1 &&
            (!this.supplierService.supplierContracts || this.supplierService.supplierContracts.length === 0)
        ) {
            // - nur ein SUPPL_CCTRS_STATUSES vorhanden
            // - noch kein Vertrag vorhanden !
            // => dann Zwangsvertrag mit ROOT-Kostenstelle aus SUPPL_CCTRS_STATUSES
            // !!! ANSONSTEN wird this.supplierService.supplierContract.costcenterId in checkRootCostcenterForContract() gefüllt !!!
            this.supplierService.supplierContract.costcenterId = this.supplierService.supplierBasedata.supplierStatus[0].costcenterId;
        }
        //
        if (this.supplierService.supplierContract.costcenterId) {
            const sc = this.costcentertreeService.findCostcenterById(
                this.environmentService.userCostcenterTree,
                this.supplierService.supplierContract.costcenterId,
            );
            if (sc) {
                this.supplierService.supplierContract._costcenterDescription = sc.shortDescription;
                this.supplierService.supplierContract._costcenterNumber = sc.costcenterNumber;
            }
        }
        // 1. PUSH DATA to list
        this.supplierService.supplierContracts.push(this.supplierService.supplierContract);
        // 2. completeContractListData
        this.selectedRowIndex = this.supplierService.supplierContracts.length - 1;
        this.supplierService.supplierContracts = this.supplierService.supplierContracts.concat();
        //
        this.initDatepicker();
        //
        this.showContractData = true;
        //
        this.modalService.closeAllModals();
    }

    /*
     ASSIGNED Kostenstellen Auswahl

     2) Zuordnung von weiteren Kostenstellen zum Vertrag
     --> MODAL: costcenterModalAssignAddMore

     */
    public addAssignedCostcenterForContract(costcenter: ICostcenter[]) {
        // console.log('addAssignedCostcenterForContract');

        this.loadingOverlayService.startLoading();

        const costcenterAssigned: number[] = [];
        if (costcenter.length > 0) {
            costcenter.forEach((cn) => {
                // console.log('addAssignedCostcenterForContract - ausgewählte ASSIGNED- Kostenstellen ID: ' + cn.id + ' NAME: ' + cn.name);
                costcenterAssigned.push(cn.id);
            });
        }

        // 2) Zuordnung von weiteren Kostenstellen zum aktuellen Vertrag

        // den akutellen Vertrag / die bestehenden costcentersAssigned, um die neue ausgewählten erweitern
        this.supplierService.supplierContract.costcentersAssigned = this.supplierService.supplierContract.costcentersAssigned.concat(costcenterAssigned);
        // den aktuellen Vertrag speichern
        this.saveSupplierContract();
    }

    /**
     *
     */
    public saveSupplierContract() {
        // den aktuellen Vertrag speichern
        this.supplierService
            .saveSupplierContract(this.supplierService.supplierContract)
            .pipe(take(1))
            .subscribe(
                (supplierContract) => {
                    let msg = '';
                    if (this.supplierService.supplierContract.id) {
                        msg = this.coreService.getMsgkey('mws.contractchangesuccessful', undefined);
                    } else {
                        msg = this.coreService.getMsgkey('mws.contractcreatesuccessful', undefined);
                    }

                    this.supplierService
                        .getSupplierBasedata()
                        .pipe(take(1))
                        .subscribe(
                            (data: any) => {
                                if (this.environmentService.appSettings.showLog)
                                    console.log(new Date() + ': ' + 'contractdata.component.ts - loadContracts ---> RESPONSE data: ' + data);
                                this.chooseContract(supplierContract, -1);

                                this.appService.showToast('success', '', msg);
                                this.contractDataChanged = true;
                                this.loadingOverlayService.stopLoading();
                            },
                            (err: IError) => {
                                this.loadContracts();
                                this.utilityHelperService.handleComponentError(err);
                            },
                        );

                    // BUG: reicht nicht aus, da bei Neuanlage die updateableCostcenter gefüllt sein müssen...
                    this.supplierService
                        .getContractsBySupplierId(this.supplierService.supplierId, this.contractfiltervalue)
                        .pipe(take(1))
                        .subscribe(
                            (data: any) => {
                                if (this.environmentService.appSettings.showLog)
                                    console.log(new Date() + ': ' + 'contractdata.component.ts - loadContracts ---> RESPONSE data: ' + data);
                                this.chooseContract(supplierContract, -1);

                                this.loadingOverlayService.stopLoading();
                            },
                            (err: IError) => {
                                this.utilityHelperService.handleComponentError(err);
                            },
                        );
                },
                (err: IError) => {
                    this.loadContracts();
                    this.utilityHelperService.handleComponentError(err);
                },
            );
    }

    public filterCostcentersWithNoContract() {
        const costcenterIds: number[] = [];
        this.supplierService.supplierContractDetail.supplierContractCostcenters.forEach((sc) => {
            costcenterIds.push(sc.costcenterId);
        });
        if (this.environmentService.appSettings.showLog) console.log(costcenterIds);
    }

    public loadContracts() {
        this.loadingOverlayService.startLoading();
        this.showContractData = false;
        this.supplierService
            .getContractsBySupplierId(this.supplierService.supplierId, this.contractfiltervalue)
            .pipe(take(1))
            .subscribe(
                (data: any) => {
                    if (this.environmentService.appSettings.showLog)
                        console.log(new Date() + ': ' + 'contractdata.component.ts - loadContracts ---> RESPONSE data: ' + data);
                    this.loadingOverlayService.stopLoading();
                },
                (err: IError) => {
                    this.utilityHelperService.handleComponentError(err);
                },
            );
    }

    public filterContracts(value: any) {
        // this.appService.showToast('info', 'Funktionalität', 'noch nicht implementiert');
        this.contractfiltervalue = value;
        console.log('contractdata.filterContracts - filterContracts: ' + this.contractfiltervalue);
        this.loadContracts();
    }

    /*
    Markiere aktuell ausgewählte Zeile in der Vertragsübersicht
    und toggled (auf-/zu-klappen) der Vertragsdetails
     */
    public chooseContract(supplierContract: ISupplierContract, index: number) {
        // console.log(row);
        if (this.selectedRowIndex === index) {
            this.showContractData = false;
            this.selectedRowIndex = undefined;
        } else {
            this.selectedRowIndex = index;
            this.supplierService.supplierContract = supplierContract;
            // get contract data
            this.loadContractDetailData(supplierContract.id);
        }
    }

    /*

     */
    public loadContractDetailData(supplierContractId?: number) {
        if (supplierContractId) {
            this.loadingOverlayService.startLoading();
            this.supplierService
                .getContractDetailByContractId(supplierContractId)
                .pipe(take(1))
                .subscribe(
                    (data: any) => {
                        if (this.environmentService.appSettings.showLog)
                            console.log(new Date() + ': ' + 'contractdata.component.ts - loadContractDetailData ---> RESPONSE data: ' + data);
                        this.fillContractData();
                        this.fillContractDetailData();
                        this.filterCostcentersWithNoContract();
                        this.showContractData = true;
                        this.loadingOverlayService.stopLoading();
                    },
                    (err: IError) => {
                        this.utilityHelperService.handleComponentError(err);
                    },
                );
        } else {
            this.initDatepicker();
            this.showContractData = true;
        }
    }

    public fillContractData() {
        // START VARIANTE 1 (vs. fillContractDetailData) - Vertragsdaten via ListenElement
        if (this.supplierService.supplierContract) {
            this.contractDatepickerForm.get('validFrom').setValue({
                isRange: false,
                singleDate: { jsDate: new Date(this.supplierService.supplierContract.validFrom) },
                dateRange: null,
            });

            this.fillContractDataValidTill();
        }
        // ENDE VARIANTE 1 - Vertragsdaten via ListenElement
    }
    public fillContractDataValidTill() {
        if (this.supplierService.supplierContract.validFrom && this.supplierService.supplierContract.validFrom.length > 0) {
            this.validTillPickerOptions = {
                appendSelectorToBody: true,
                dateRange: false,
                dateFormat: 'dd.mm.yyyy',
                disableUntil: this.coreService.convertToMyDate(new Date(this.supplierService.supplierContract.validFrom)),
            };
        }
        let modelTill: IMyDateModel;
        if (this.supplierService.supplierContract.validTill && this.supplierService.supplierContract.validTill.length > 0) {
            modelTill = { isRange: false, singleDate: { jsDate: new Date(this.supplierService.supplierContract.validTill) }, dateRange: null };
        }
        this.contractDatepickerForm.get('validTill').setValue(modelTill);
    }

    public fillContractDetailData() {
        // START VARIANTE 2 (vs. fillContractData) - Vertragsdaten via Rückgabe der supplierContractDetail
        // if (this.supplierService.supplierContractDetail.supplierContract) {
        //     const dateFrom: Date = new Date(this.supplierService.supplierContractDetail.supplierContract.dateFrom);
        //     const modelFrom: IMyDateModel = {isRange: false, singleDate: {jsDate: dateFrom}, dateRange: null};
        //     this.myContractDatepickerForm.get('dateFromForm').setValue({
        //         date: modelFrom,
        //         options: new DatepickerHelper().datePickerOptions
        //     });
        //     if (this.supplierService.supplierContract.dateTill && this.supplierService.supplierContractDetail.supplierContract.dateTill.length>0) {
        //         const dateTill: Date = new Date(this.supplierService.supplierContract.dateTill);
        //         const modelTill: IMyDateModel = {isRange: false, singleDate: {jsDate: dateTill}, dateRange: null};
        //         this.myContractDatepickerForm.get('dateTillForm').setValue({
        //             date: modelTill,
        //             options: new DatepickerHelper().datePickerOptions
        //         });
        //     }
        // }
        // ENDE VARIANTE 2 - Vertragsdaten via Rückgabe der supplierContractDetail
        if (this.supplierService.supplierContractDetail) {
            this.vereinbarungsrelevante = []; // alle zugeordneten
            this.abweichendeBedingungenMoeglich = [];
            this.abweichendeBedingungenBereitsKundenExistent = [];

            // if (this.supplierService.supplierContract.costcentersAssigned && this.supplierService.supplierContract.costcentersAssigned.length>0) {
            //     this.supplierService.supplierContract.costcentersAssigned.forEach( cAssigned => {
            //         if (this.supplierService.supplierContractDetail.supplierContractCostcenters
            //             && this.supplierService.supplierContractDetail.supplierContractCostcenters.length>0
            //             && this.supplierService.supplierContractDetail.supplierContractCostcenters.find( scc => scc.costcenterId === cAssigned) ) {
            //             // zugeordnet UND bereits als Ausnahme definiert
            //             // für diese Kostenstellen sind bereits Kunden definiert. Diese müssen als abweichende Bedingungen aufgelistet werden
            //             this.abweichendeBedingungenBereitsExistent.push(this.costcentertreeService.findCostcenterById(this.costcentertreeService.costcenterTree, cAssigned));
            //         } else {
            //             // hier sind noch keine Kunden angegelegt. Für diese Kostenstellen können noch abweichende Bedingungen NEU angelegt werden !
            //             this.abweichendeBedingungenMoeglich.push(this.costcentertreeService.findCostcenterById(this.costcentertreeService.costcenterTree, cAssigned));
            //         }
            //         this.vereinbarungsrelevante.push(this.costcentertreeService.findCostcenterById(this.costcentertreeService.costcenterTree, cAssigned));
            //     })
            // }

            // complete supplierContractCostcenter
            if (
                this.supplierService.supplierContractDetail.supplierContractCostcenters &&
                this.supplierService.supplierContractDetail.supplierContractCostcenters.length > 0
            ) {
                this.supplierService.supplierContractDetail.supplierContractCostcenters.forEach((scc) => {
                    scc._costcenter = this.costcentertreeService.findCostcenterById(this.environmentService.userCostcenterTree, scc.costcenterId);
                    if (scc.supplierContractCostcenterCustomers && scc.supplierContractCostcenterCustomers.length > 0) {
                        // für diese Kostenstellen sind bereits Kunden definiert. Diese müssen als abweichende Bedingungen aufgelistet werden
                        this.abweichendeBedingungenBereitsKundenExistent.push(
                            this.costcentertreeService.findCostcenterById(this.environmentService.userCostcenterTree, scc.costcenterId),
                        );
                        // 2020-11-24 RA: auch Kostenstellen mit bereits zugeordneten Kunden können gelöscht werden !
                        this.abweichendeBedingungenMoeglich.push(
                            this.costcentertreeService.findCostcenterById(this.environmentService.userCostcenterTree, scc.costcenterId),
                        );
                    } else {
                        // hier sind noch keine Kunden angegelegt. Für diese Kostenstellen können noch abweichende Bedingungen NEU angelegt werden !
                        this.abweichendeBedingungenMoeglich.push(
                            this.costcentertreeService.findCostcenterById(this.environmentService.userCostcenterTree, scc.costcenterId),
                        );
                    }
                    this.vereinbarungsrelevante.push(
                        this.costcentertreeService.findCostcenterById(this.environmentService.userCostcenterTree, scc.costcenterId),
                    );
                });
            }
            //
            this.supplierService.supplierContractDetail._mainSupplierContractCostcenter = this.costcentertreeService.findCostcenterById(
                this.environmentService.userCostcenterTree,
                this.supplierService.supplierContract.costcenterId,
            );
            //
            this.supplierContractMainCostcenter = this.supplierService.supplierContractDetail.supplierContractCostcenters.find(
                (scc) => scc.costcenterId === this.supplierService.supplierContract.costcenterId,
            );
            if (this.supplierContractMainCostcenter && this.supplierContractMainCostcenter.costcenterId) {
                this.supplierContractMainCostcenter._costcenter = this.costcentertreeService.findCostcenterById(
                    this.environmentService.userCostcenterTree,
                    this.supplierContractMainCostcenter.costcenterId,
                );
            }
        }
    }

    public submitContractData(): void {
        this.loadingOverlayService.startLoading();

        // VARIANTE date-picker Component
        if (
            this.contractDatepickerForm.get('validFrom').value &&
            this.contractDatepickerForm.get('validFrom').value.singleDate &&
            this.contractDatepickerForm.get('validFrom').value.singleDate.jsDate
        ) {
            this.supplierService.supplierContract.validFrom = this.contractDatepickerForm.get('validFrom').value.singleDate.jsDate;
        } else {
            this.supplierService.supplierContract.validFrom = undefined;
        }
        if (
            this.contractDatepickerForm.get('validTill').value &&
            this.contractDatepickerForm.get('validTill').value.singleDate &&
            this.contractDatepickerForm.get('validTill').value.singleDate.jsDate
        ) {
            this.supplierService.supplierContract.validTill = this.contractDatepickerForm.get('validTill').value.singleDate.jsDate;
        } else {
            this.supplierService.supplierContract.validTill = undefined;
        }

        // VARIANTE oc-date-picker Component
        // const dateFromPicker = this.contractDatepickerForm.get('dateFromForm').get('date').value.singleDate ? this.contractDatepickerForm.get('dateFromForm').get('date').value.singleDate.jsDate : undefined;
        // const dateTillPicker = this.contractDatepickerForm.get('dateTillForm').get('date').value.singleDate ? this.contractDatepickerForm.get('dateTillForm').get('date').value.singleDate.jsDate : undefined;
        // this.supplierService.supplierContract.validFrom = dateFromPicker ? dateFromPicker : undefined
        // this.supplierService.supplierContract.validTill = dateTillPicker ? dateTillPicker : undefined

        this.loadingOverlayService.startLoading();
        this.saveSupplierContract();
    }

    public resetContractData() {
        // this.myDpTill.clearDate();
        this.contractDataChanged = true;
        this.showContractData = false;
    }

    public isUpdateable(sccId: number) {
        let sccUpdateable;
        if (this.supplierService.supplierBasedata.updatableCustomerCostcenters) {
            sccUpdateable = this.supplierService.supplierBasedata.updatableCustomerCostcenters.find((scCostcenterId) => scCostcenterId === sccId);
        }
        return sccUpdateable ? true : false;
    }

    /*
     angular-mydatepicker NACHFOLGER VON mydatepicker !!!
     https://github.com/kekeh/angular-mydatepicker/wiki
     https://github.com/kekeh/angular-mydatepicker
     https://github.com/kekeh/angular-mydatepicker/tree/master/example/app/date-picker-reactive-forms

     */
    public initDatepicker() {
        this.contractDatepickerForm = this.formBuilder.group({
            validFrom: [
                {
                    value: undefined,
                    disabled: false, // !this.coreService.checkAbility('create', 'usermanagement.validFrom')
                },
                [
                    ocValidator(
                        this.ocJsonSchemaValidatorAjv,
                        this.environmentService,
                        'supplierContract',
                        'validFrom',
                        this.coreService.getMsgkey('mws.datefrom', undefined),
                    ),
                ],
            ],
            validTill: [
                {
                    value: undefined,
                    disabled: false, // !this.coreService.checkAbility('create', 'usermanagement.validTill')
                },
                [
                    ocValidator(
                        this.ocJsonSchemaValidatorAjv,
                        this.environmentService,
                        'supplierContract',
                        'validTill',
                        this.coreService.getMsgkey('mws.datetill', undefined),
                    ),
                ],
            ],

            changed: false,
        });
    }

    public initTableColumns() {
        this.contractColumns = ['id', 'dateFrom', 'dateTill', 'costcenters', 'edit'];
    }

    public onDateFromChanged(event: IMyDateModel) {
        // console.log('*** toggleCalendar - onDateFromChanged(): ', event);
        // VARIANTE date-picker Component
        this.validTillPickerOptions = {
            appendSelectorToBody: true,
            dateRange: false,
            dateFormat: 'dd.mm.yyyy',
            disableUntil: this.coreService.convertToMyDate(event.singleDate.jsDate),
        };
        if (
            !this.contractDatepickerForm.get('validTill').value ||
            event.singleDate.jsDate > this.contractDatepickerForm.get('validTill').value.singleDate.jsDate
        ) {
            this.contractDatepickerForm.get('validTill').setValue(undefined);
        }

        // VARIANTE oc-date-picker Component
        // (this.contractDatepickerForm.get('dateTillForm').get('options').value as IAngularMyDpOptions).disableUntil = this.coreService.convertToMyDate(event.singleDate.jsDate);
        // this.contractDatepickerForm.get('dateTillForm').get('options').setValue(Object.assign({}, this.contractDatepickerForm.get('dateTillForm').get('options').value));
        this.contractDataChanged = false;
    }
    public onDateTillChanged(event: IMyDateModel) {
        // console.log('*** toggleCalendar - onDateTillChanged(): ', event);
        this.contractDataChanged = false;
    }

    /*
    Anzeige aller Kostenstellen (AS TREE) die keinen aktuell gültigen Vertrag haben !
    *** NEU:
        - einstufig, wenn kein ROOT-Vertrag besteht dann wird dieser zwangsangelegt und es können nur noch vereinbarungsrelevante Koststellen zugeordnet werden
            1) Zuordnung der vertragsrelevanten Kostenstellen   -> openCostcenterModalAssign
        - zweistufig, wenn bereits ein ROOT-Vertrag (Vereinbarungs-Kostenstelle) existiert
            1) Auswahl ROOT-Kostenstelle                        -> openCostcenterModalRoot
            2) Zuordnung der vertragsrelevanten Kostenstellen   -> openCostcenterModalAssign
     */
    public openNewContractCostcenterModal() {
        if (
            this.supplierService.supplierBasedata.supplierStatus.length === 1 &&
            (!this.supplierService.supplierContracts || this.supplierService.supplierContracts.length === 0)
        ) {
            // => noch kein Vertrag vorhanden, Status-Kostenstelle ist ROOT-Kostenstelle
            // direkter Einstieg in Auswahl der ASSIGNED Kostenstellen
            if (!this.supplierService.supplierContract) this.supplierService.supplierContract = {} as ISupplierContract;
            this.supplierService.supplierContract.costcenterId = this.supplierService.supplierBasedata.supplierStatus[0].costcenterId;
            // - hole relevante Kostenstellen ausgehend von: supplierContract.costcenterId --- ROOT-Kostenstelle
            // - öffne modales Fenster: ASSIGN-COSTCENTER
            this.openCostcenterModalAssign();
        } else {
            // - hole relevante Kostenstellen ausgehend von: systemUserCostcenterId
            // - öffne modales Fenster: ROOT-COSTCENTER
            this.openCostcenterModalRoot();
        }
    }

    /*
    Ermittelt alle Kostenstellen die keinen gültigen Vertrag haben
    WICHTIG: AB DER KOSTENSTELLE DIE DER BENUTZER AUSGEWÄHLT HAT !!!
        -> this.environmentService.systemUserCostcenterId
     */
    public openCostcenterModalRoot() {
        // this.costcentertreeService.getCostcenterTreeWithoutValidContract(this.environmentService.systemUserCostcenterId).subscribe(costcenters => {
        this.costcentertreeService
            .getCostcenterTreeByTreeNode(this.environmentService.currentUserCostcenterId)
            .pipe(take(1))
            .subscribe(
                (costcenters) => {
                    // this.nodes = costcenters;
                    this.nodes = [];
                    this.nodes.push(costcenters);
                    const options: NgbModalOptions = { centered: false, backdrop: 'static', windowClass: 'modal-lg animate' };
                    this.modalService.openModal(this.costcenterModalRoot(), options);
                },
                (err: IError) => {
                    this.utilityHelperService.handleComponentError(err);
                },
            );
    }

    /*
    Ermittelt alle Kostenstellen
    WICHTIG: AB DER KOSTENSTELLE DIE DIE ROOT_KOSTENSTELLE IST !!!
        -> this.supplierService.supplierContract.costcenterId
     */
    public openCostcenterModalAssign() {
        this.costcentertreeService
            .getCostcenterTreeByTreeNode(this.supplierService.supplierContract.costcenterId)
            .pipe(take(1))
            .subscribe(
                (costcenters) => {
                    if (costcenters && costcenters.children && costcenters.children.length > 0) {
                        this.costcenterTreeDisabled = false;
                        this.costcenterTreeExpandAll = true;
                        this.costcenterTreeTriState = false;
                        //
                        // DISABLE - ROOT Costcenter
                        // let c = this.costcentertreeService.findCostcenterById(costcenters, this.supplierService.supplierContract.costcenterId);
                        // c['disabled'] = true;
                        //
                        this.nodes = [];
                        this.nodes.push(costcenters);
                        const options: NgbModalOptions = { centered: false, backdrop: 'static', windowClass: 'modal-lg animate' };
                        this.modalService.openModal(this.costcenterModalAssign(), options);
                    } else {
                        // ROOT Costcenter hat keine weiteren CHILDREN-Elemente !!!
                        // => ROOT Costcenter === ASSIGNED Costcenter
                        this.costcentertreeService.addSpecialAttributesToICostcenterObject(costcenters);
                        const costcenterAsTreeNodes = [];
                        costcenterAsTreeNodes.push(costcenters);
                        //
                        this.checkAssignedCostcenterForContract(costcenterAsTreeNodes);
                    }
                },
                (err: IError) => {
                    this.utilityHelperService.handleComponentError(err);
                },
            );
    }

    public openCostcenterModalAssignAddMoreCostcenter() {
        this.costcentertreeService
            .getCostcenterTreeByTreeNode(this.supplierService.supplierContract.costcenterId)
            .pipe(take(1))
            .subscribe(
                (costcenters) => {
                    this.costcenterTreeDisabled = false;
                    this.costcenterTreeExpandAll = true;
                    this.costcenterTreeTriState = false;
                    //
                    // DISABLE - ROOT Costcenter
                    // let c = this.costcentertreeService.findCostcenterById(costcenters, this.supplierService.supplierContract.costcenterId);
                    // c['disabled'] = true;
                    // DISABLE - ASSIGNED Costcenter
                    let c;
                    this.supplierService.supplierContract.costcentersAssigned.forEach((costcenterid) => {
                        c = this.costcentertreeService.findCostcenterById(costcenters, costcenterid);
                        c['disabled'] = true;
                    });
                    //
                    this.nodes = [];
                    this.nodes.push(costcenters);
                    const options: NgbModalOptions = { centered: false, backdrop: 'static', windowClass: 'modal-lg animate' };
                    this.modalService.openModal(this.costcenterModalAssignAddMoreCostcenter(), options);
                },
                (err: IError) => {
                    this.utilityHelperService.handleComponentError(err);
                },
            );
    }

    /*
    Anzeige der zugeordneten, unterhalb des Wurzelknoten liegenenden Kostenstellen (AS LIST)
    um hier Ausnahme-Lieferbedingungen zu definieren oder definierte Ausnahme-Lieferbedingungen zu INAKTIVIEREN
     */
    public openAssignedCostcenterModal() {
        this.costcenterModalHeadline = this.coreService.getMsgkey('mws.deleteassignedcostcenter', undefined);
        this.showCostcenterListCheckBox = true;
        this.displayedCostcenterListColumns = ['checkBox', 'costcenterNumber', 'description'];
        this.costcenterList = this.abweichendeBedingungenMoeglich;
        this.modalService.openModal(this.costcenterListModal());
    }

    public deleteAssignedCostcenter(costcenters: ICostcenter[]) {
        costcenters.forEach((c) => {
            // console.log('Zuordnung von Kostenstelle: ' + c.description + 'zurücknehmen!');
            this.supplierService.supplierContract.costcentersAssigned.splice(
                this.supplierService.supplierContract.costcentersAssigned.findIndex((scaId) => scaId === c.id),
                1,
            );
        });
        // HILFSAUSGABE !!!
        // this.supplierService.supplierContract.costcentersAssigned.forEach( scaId => console.log('---> NOCH DRIN: scaId' + scaId) );

        this.supplierService
            .saveSupplierContract(this.supplierService.supplierContract)
            .pipe(take(1))
            .subscribe(
                (supplierContract) => {
                    // load new contractDetailData
                    this.supplierService
                        .getContractDetailByContractId(supplierContract.id)
                        .pipe(take(1))
                        .subscribe(
                            (ok) => {},
                            (err: IError) => {
                                this.utilityHelperService.handleComponentError(err);
                            },
                        );
                },
                (err: IError) => {
                    this.utilityHelperService.handleComponentError(err);
                },
            );
        // this.appService.showToast('info', 'Funktionaliät fehlt', "Der Service /supplier/contractCostcenter/delete fehlt.");
    }

    /*
    Reine Anzeige der dem Vertrag zugeordneten Kostenstellen.
     */
    // openAssignedCostcenterModal() {
    //     this.costcenterModalHeadline = this.coreService.getMsgkey("mws.viewcostcenters", undefined);
    //     this.showCostcenterListCheckBox = false;
    //     this.displayedCostcenterListColumns = ['costcenterNumber', 'description'];
    //     this.costcenterList = this.vereinbarungsrelevante;
    //     this.modalService.openModal(this.costcenterListModal);
    // }

    public isActualDate(date: string) {
        // console.log('--> ' + date);
        // console.log(moment(new Date()) + ' <> ' + moment(new Date(date)));
        const x = moment(new Date()).isAfter(moment(new Date(date)));
        // console.log('--> ' + x);
        return x;
    }
}
